module.exports = __webpack_public_path__ + "img/child.520178b2.svg";